import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "email-configuration"
    }}>{`Email Configuration`}</h1>
    <p>{`Laravel supports a variety of mail transport drivers to be used while sending an e-mail. Today we will walk you through two types of email service configuration step by step. We will discuss Mailgun and Gmail SMTP configuration here.`}</p>
    <h2 {...{
      "id": "mailgun-configuration"
    }}>{`Mailgun Configuration`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Sandbox domains are restricted to authorized recipients only. If you want to receive your email in sandbox account. Please authorize your email. Up to 5 Authorized Recipients can be added.`}</p>
    </blockquote>
    <p><img alt="authorized-notice-image" src={require("./images/email-config/mailgun/authorized-notice.png")} /></p>
    <p>{`For more information, Please follow `}<a parentName="p" {...{
        "href": "https://help.mailgun.com/hc/en-us/articles/217531258"
      }}>{`Authorized Recipients `}</a></p>
    <p>{`To setup and configure Mailgun you need to set these below `}<inlineCode parentName="p">{`.env`}</inlineCode>{` keys. We will discuss how you can get those env variable from mailgun. `}</p>
    <pre><code parentName="pre" {...{}}>{`MAIL_MAILER=
MAIL_HOST=
MAILGUN_DOMAIN=
MAILGUN_SECRET=
MAIL_FROM_ADDRESS=
MAIL_PORT=587
MAIL_USERNAME=null
MAIL_PASSWORD=null
MAIL_ENCRYPTION=null
ADMIN_EMAIL=support@example.com
`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`MAIL_MAILER=mailgun`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`MAIL_HOST=smtp.mailgun.org`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`To get `}<inlineCode parentName="p">{`MAILGUN_DOMAIN`}</inlineCode>{` Create or SignIn a Mailgun account from here `}<a parentName="p" {...{
            "href": "https://login.mailgun.com/login"
          }}>{`https://login.mailgun.com/login`}</a>{` After login click sending you will see a domain list there. I will go with this domain below. Just copy this domain and set this as your `}<inlineCode parentName="p">{`MAILGUN_DOMAIN`}</inlineCode></p>
        <p parentName="li"><img alt="mailgun-domain-image" src={require("./images/email-config/mailgun/mailgun-domain.png")} /></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Now to obtain `}<inlineCode parentName="p">{`MAILGUN_SECRET`}</inlineCode>{` click on on that domain. You will redirect to an over page like below click on API Keys. `}</p>
        <p parentName="li"><img alt="mailgun-api-key-image" src={require("./images/email-config/mailgun/mailgun-api-key.png")} /></p>
        <p parentName="li">{`Then it will redirect to page find `}<inlineCode parentName="p">{`Mailgun API keys`}</inlineCode>{` then click on `}<inlineCode parentName="p">{`Add new key`}</inlineCode></p>
        <p parentName="li"><img alt="mailgun-create-key-image" src={require("./images/email-config/mailgun/mailgun-create-key.png")} />{`
`}<img alt="mailgun-get-api-key-image" src={require("./images/email-config/mailgun/mailgun-get-api-key.png")} /></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`To set `}<inlineCode parentName="p">{`MAIL_FROM_ADDRESS`}</inlineCode>{` just type your mail address.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Now go to the dashboard -> sending -> Domain Click on the domain then select SMTP. You will see     `}</p>
      </li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`MAIL_PORT=587
MAIL_USERNAME=null
`}</code></pre>
    <p>{`configuration information there like below.`}</p>
    <p>{` `}<img alt="overview-smtp-config-image" src={require("./images/email-config/mailgun/overview-smtp-config.png")} /></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`In a Mailgun configuration, you typically don't need to specify a `}<inlineCode parentName="p">{`MAIL_PASSWORD`}</inlineCode>{` because Mailgun uses API keys for authentication, not SMTP passwords. You can set `}<inlineCode parentName="p">{`MAIL_PASSWORD=null`}</inlineCode>{` or remove it from your .env file.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Set your MAIL_ENCRYPTION `}<inlineCode parentName="p">{`MAIL_ENCRYPTION=tls`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can set your admin email `}<inlineCode parentName="p">{`ADMIN_EMAIL=your_email@example.com`}</inlineCode></p>
      </li>
    </ul>
    <h2 {...{
      "id": "gmail-smtp-configuration"
    }}>{`Gmail SMTP Configuration`}</h2>
    <p>{`To setup Gmail SMTP Configuration you need to set these below `}<inlineCode parentName="p">{`.env`}</inlineCode>{` keys. We will discuss how you can get those env variable from Gmail.`}</p>
    <pre><code parentName="pre" {...{}}>{`MAIL_MAILER=
MAIL_HOST=
MAILGUN_DOMAIN=
MAILGUN_SECRET=
MAIL_FROM_ADDRESS=
MAIL_PORT=587
MAIL_USERNAME=null
MAIL_PASSWORD=null
MAIL_ENCRYPTION=null
ADMIN_EMAIL=support@example.com
`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`MAIL_MAILER=smtp`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`MAIL_HOST=smtp.gmail.com`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can ignore `}<inlineCode parentName="p">{`MAILGUN_DOMAIN`}</inlineCode>{` `}<inlineCode parentName="p">{`MAILGUN_SECRET`}</inlineCode>{` for gmail.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`To set `}<inlineCode parentName="p">{`MAIL_FROM_ADDRESS`}</inlineCode>{` just type your mail address.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`MAIL_PORT=587`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`To set `}<inlineCode parentName="p">{`MAIL_USERNAME=your@gmail.com`}</inlineCode>{` just type your gmail address that you are using for configuration.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`To get MAIL_PASSWORD from google Create or SignIn to a gmail account. Then go to your account or click the URL `}<a parentName="p" {...{
            "href": "https://myaccount.google.com/security"
          }}>{`https://myaccount.google.com/security`}</a>{` Then turn on 2-Step Verification. `}</p>
        <p parentName="li"><img alt="gmail-security-image" src={require("./images/email-config/gmail/gmail-security.png")} /></p>
        <p parentName="li">{`Under 2-Step Verification settings you will see app passwords and click that -`}</p>
        <p parentName="li"><img alt="two-step-verification-image" src={require("./images/email-config/gmail/two-step-verification.png")} /></p>
        <p parentName="li">{`now set your application name under other (custom name)`}</p>
        <p parentName="li"><img alt="set-app-name-image" src={require("./images/email-config/gmail/set-app-name.png")} /></p>
        <p parentName="li">{`after typing the name click on generate a propt will popup. like below That is your `}<inlineCode parentName="p">{`MAIL_PASSWORD`}</inlineCode>{` copy that.`}</p>
        <p parentName="li"><img alt="generated-app-password-image" src={require("./images/email-config/gmail/generated-app-password.png")} /></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Set your MAIL_ENCRYPTION `}<inlineCode parentName="p">{`MAIL_ENCRYPTION=tls`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can set your admin email `}<inlineCode parentName="p">{`ADMIN_EMAIL=your_email@example.com`}</inlineCode></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      